import React, { Component } from 'react';
import { Tabs, List, Picker, Toast, TextareaItem, Checkbox, Flex, Accordion, Card, Modal, WhiteSpace } from 'antd-mobile';
import { CommonlyHeadMembers } from '../../common/headnav';
import $ from "jquery";
import * as services from '../../projects/services';
import { createBrowserHistory } from "history";
import * as fun from '../../../components/common';
import './style.less';
const history = createBrowserHistory();
const tabs = [
    { title: '申请解读', sub: '1' },
    { title: '解读记录', sub: '2' }
];
const AgreeItem = Checkbox.AgreeItem;
let firstshow = false;
export default class InterpretList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tabs: tabs,
            oid: 0,
            reportData: [],
            reportId: '',
            radioValue: true,
            ckmm: '',
            content: '',
            interpretationList: [],
            modal1: false,
            threadid: '',
            content2: '',
            bannerList: [],
        }
        this.onChangeRadio = this.onChangeRadio.bind(this);
        this.addDecode = this.addDecode.bind(this);
        this.textChange = this.textChange.bind(this);
        this.onChangeAccordion = this.onChangeAccordion.bind(this);
    }
    onChangeRadio = (e) => {
        this.setState({
            radioValue: e.target.checked
        }
        )
    };
    textChange = (e) => {
        this.setState({
            content: e
        });
    }
    onTabClick = (tab, index) => {
        this.setState({
            oid: index
        });
        $("html,body").animate({
            scrollTop: 0
        }, 0);
    }
    GetadvertisementList = () => {
        services.GetadvertisementList(global.advertisement.advertisement_wxinterpret, '').then(data => {
            if (data.status === 0) {
                this.setState({ bannerList: data.result });
            }
        });
    }
    componentDidMount() {
        this.GetadvertisementList();
        firstshow = true;
        let parms = { page: 1, rows: 100 }
        let st = [];
        st.push(parseInt(this.props.match.params.reoprtId));
        this.setState({ reportId: st });
        services.GetReportList(parms, '').then(data => {
            if (data.status === 0) {

                if (data.result.total > 0) {
                    let rdata = data.result.rows;
                    let reportData = [];
                    rdata.forEach(element => {
                        let time = fun.FormatTime(element.createtime, 'YYYY-MM-dd');
                        reportData.push({ value: element.reportid, label: element.realname + '' + time + '' + element.mcname, text: element.ckmm });
                    });
                    var ckmm = reportData.find(value => parseInt(value.value) === parseInt(this.props.match.params.reoprtId));

                    this.setState({ reportData: reportData, ckmm: !!ckmm ? ckmm.text : '' });
                }
            } else {
                Toast.offline(data.message);
            }
        });

        this.getInterpretationList();

    }
    getInterpretationList = () => {
        let parms = { page: 1, rows: 100 }
        services.GetInterpretationList(parms, '').then(data => {
            if (data.status === 0) {
                let data1 = data.result.answer;
                let data2 = data.result.put;
                data1.push.apply(data1, data2);
                let sortArr = data1.sort((a, b) => { return a.postid - b.postid; });

                const sorted = this.groupBy(sortArr, function (item) {
                    return [item.threadid];
                });
                this.setState({ interpretationList: sorted.reverse() });
            } else {
                Toast.offline(data.message);
            }

        });
    }
    onReport = (e) => {
        if (parseInt(e) !== 0) {
            let mc = this.state.reportData.find((value) => value.value === e[0]);
            this.setState({ reportId: e, ckmm: mc.text });
        }
    }
    groupBy = (array, f) => {
        const groups = {};
        array.forEach(function (o) {
            const group = JSON.stringify(f(o));
            groups[group] = groups[group] || [];
            groups[group].push(o);
        });
        return Object.keys(groups).map(function (group) {
            return groups[group];
        });
    }
    addDecode = () => {
        let reportId = this.state.reportId;
        if (Array.isArray(reportId)) {
            reportId = parseInt(reportId[0]);
        } else {
            reportId = parseInt(reportId);
        }
        if (!!reportId === false || reportId === 0) {
            Toast.offline('请选择您需要解读的报告');
            return false;
        }
        if (this.state.content === '') {
            Toast.offline('请输入您要查询的内容');
            return false;
        }

        let parms = { reportId: reportId, content: this.state.content, ckmm: this.state.ckmm }

        services.Adddecode(parms, '正在申请，请稍后').then(data => {
            if (data.status === 0) {
                Toast.success(data.message, 1, () => {
                    this.getInterpretationList();
                    setTimeout(this.setState({ oid: 1 }), 3000);
                });

            } else {
                Toast.offline(data.message);
            }
        });

    }
    onChangeAccordion = (key) => {

    }
    showModal = (key, value) => (e) => {
        e.preventDefault(); // 修复 Android 上点击穿透
        this.setState({
            [key]: true, threadid: value
        });
    }
    onClose = key => () => {
        this.setState({
            [key]: false,
        });
    }
    textChange2 = (e) => {
        this.setState({
            content2: e
        });
    }
    canleorder = () => {
        if (this.state.content2 === '') {
            Toast.offline('您的回复不能为空！');
            return false;
        }

        let parms = { threadId: this.state.threadid, content: this.state.content2 }
        services.AddThread(parms, '正在申请，请稍后').then(data => {
            if (data.status === 0) {
                Toast.success(data.message, 1, () => {
                    this.setState({
                        modal1: false
                    });
                    this.getInterpretationList();

                });
            } else {
                Toast.offline(data.message);
            }
        });
    }
     //链接跳转
     openlink =(data,e) =>
     {
         if(!!data)
         {
             if(fun.IsWebsite(data.link) )
             {            
                 window.location.href = fun.IsHttp(data.link);
             }else if(data.link !=='' && data.link !=='/')
             {
                 history.push(data.link);
                 history.go();
             }
         }
     }
    render() {
        const { tabs, reportData, interpretationList } = this.state;
        return <div className="interpretList">
            <CommonlyHeadMembers barname="报告解读" />
            <Tabs tabs={tabs}
                tabBarPosition="top"
                useOnPan={true}
                swipeable={true}
                page={this.state.oid}
                onTabClick={(tab, index) => { this.onTabClick(tab, index) }}
                onChange={(tab, index) => { this.onTabClick(tab, index) }}
            >
                <div className="interpret_box">
                    {
                        firstshow && reportData.length === 0 ? <div className="errordiv"><img alt='' src={require('../../../res/images/zwsj.png')} />
                            <p>您暂时没有可以解读的体检报告，<br></br>请添加报告后进行解读</p>
                        </div> :
                            <div>
                                <List>
                                    <Picker
                                        className="mPicker"
                                        data={reportData}
                                        value={this.state.reportId}
                                        cols={1}
                                        onChange={this.onReport}
                                        extra="请选择要解读的报告"
                                    >
                                        <List.Item arrow="horizontal">体检报告：</List.Item>
                                    </Picker>
                                    <TextareaItem
                                        placeholder="可输入多行文本"
                                        title="咨询内容"
                                        rows={5}
                                        onChange={this.textChange}

                                    />
                                </List>
                                <Flex>
                                    <Flex.Item>
                                        <AgreeItem data-seed="logId" defaultChecked disabled  >授权专家查看我的体检报告
                            </AgreeItem>
                                    </Flex.Item>
                                </Flex>

                                <Flex>
                                    <Flex.Item><button type="button" className="subbut" onClick={this.addDecode} >申请解读</button></Flex.Item>
                                </Flex>
                            </div>
                    }
                    <WhiteSpace />
                    <WhiteSpace />
                    <div className="advertisementbox">
                        {
                            this.state.bannerList.length > 0 ?
                                this.state.bannerList.map((data, index) => (
                                    <div className="advertisement" key={index}>
                                        <img alt={data.title}  src={data.picpath} onClick={this.openlink.bind(this,data)} /> 
                                    </div>
                                ))
                                : ''
                        }
                    </div>
                </div>
                <div className="interpret_box">
                    {
                        firstshow && interpretationList.length === 0 ? <div className="errordiv"><img alt='' src={require('../../../res/images/zwsj.png')} />
                            <p>您还没有报告解读记录</p>
                        </div> :
                            <Accordion defaultActiveKey="0" accordion className="my-accordion" onChange={this.onChangeAccordion}>
                                {
                                    interpretationList.length === 0 ? '' :
                                        interpretationList.map((data, index) => (
                                            <Accordion.Panel key={index} header={index + 1 + '、' + data[0].content}>
                                                {
                                                    data.map((data2, index2) => (

                                                        <Card full key={index2}>
                                                            <Card.Header
                                                                title={data2.posttype === 1 ? '我' : '专家解读'}
                                                                thumb={data2.posttype === 1 ? require('../../../res/images/user/kh.png') : require('../../../res/images/logo.png')}
                                                                extra={<span>{fun.FormatTime(data2.createtime, 'yyyy-MM-dd hh:mm:ss')}</span>}
                                                            />
                                                            <Card.Body>
                                                                <div>{data2.content}</div>
                                                            </Card.Body>
                                                        </Card>

                                                    ))
                                                }
                                                <WhiteSpace size="lg" />
                                                <button type="button" className=" subbut2" onClick={this.showModal('modal1', data[0].threadid)} >回复</button>
                                                <WhiteSpace size="lg" />
                                            </Accordion.Panel>
                                        ))
                                }

                            </Accordion>
                    }

                </div>

            </Tabs>

            <Modal
                className="interpretModal"
                visible={this.state.modal1}
                transparent
                closable={true}
                maskClosable={true}
                onClose={this.onClose('modal1')}
                title="解读回复 "
                wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                afterClose={() => { }}
                footer={[{ text: '取消', onPress: () => { this.onClose('modal1')(); } },
                { text: '确定回复', onPress: () => { this.canleorder() } }
                ]}
            >
                <TextareaItem
                    placeholder="可输入多行文本"
                    title="咨询内容"
                    rows={5}
                    onChange={this.textChange2}
                />
            </Modal>


        </div>;
    }

}